import React from "react";

const BuildingAltIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 517 511"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M340.667 502.483H170.333V468.417H340.667V502.483ZM306.6 434.35H204.4V400.283H306.6V434.35ZM476.933 8.51666V59.6167H511V93.6833H476.933V349.183C476.933 357.921 470.358 365.127 461.893 366.097L459.9 366.217H51.1C42.3619 366.217 35.1568 359.642 34.1859 351.176L34.0667 349.183V93.6833H0V59.6167H442.867V8.51666H476.933ZM442.867 93.6833H68.1333V332.15H187.367V195.883C187.367 187.145 193.942 179.94 202.407 178.969L204.4 178.85H306.6C315.338 178.85 322.543 185.425 323.514 193.89L323.633 195.883V332.15H442.867V93.6833ZM289.567 212.917H221.433V332.15H289.567V212.917ZM391.767 127.75C401.169 127.75 408.8 135.381 408.8 144.783C408.8 154.186 401.169 161.817 391.767 161.817C382.364 161.817 374.733 154.186 374.733 144.783C374.733 135.381 382.364 127.75 391.767 127.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BuildingAltIcon;
